import {
  ChangeEventHandler,
  ForwardedRef,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import classNames from 'classnames';
import { Modal } from 'src/common/components';
import { ModalRefProps } from 'src/common/components/Modal';
import { campaignTypes } from 'src/tcr/types';

interface ScalingModalProps {
  onSave?: (item: any, brand_id: string, campaign_type: string) => void;
}

export const ScalingModal = forwardRef(
  ({ onSave = () => {} }: ScalingModalProps, ref: ForwardedRef<ModalRefProps>): JSX.Element => {
    const [selectedType, setSelectedType] = useState<string>('');
    const tenantRef = useRef<any>();
    const brandRef = useRef<string>('');
    const modalRef = useRef<ModalRefProps>(null);

    useImperativeHandle(ref, () => ({
      show: (item: any, brand_id: string) => {
        const campaign_type = item?.campaign_type || campaignTypes[0]?.id;
        setSelectedType(campaign_type as string);
        tenantRef.current = item;
        brandRef.current = brand_id;
        modalRef.current?.show();
      },
      hide: () => modalRef.current?.hide(),
    }));

    const handleSelectType: ChangeEventHandler<HTMLInputElement> = (e) => {
      setSelectedType(e.currentTarget.id);
    };

    const handleAccept = (): void => {
      onSave(tenantRef.current, brandRef.current, selectedType);
    };

    return (
      <Modal
        cancelText="Cancel"
        actionText="Accept"
        actionFunc={handleAccept}
        disabled={!selectedType}
        ref={modalRef}
      >
        <div>
          <h3>Select new campaign type</h3>
          <ul className="h-80 mt-4 overflow-auto">
            {campaignTypes.map((campaign, index) => {
              const className = index !== campaignTypes.length - 1 ? 'border-b' : '';
              return (
                <li
                  key={campaign.id}
                  className={classNames(
                    'bg-white-0.0 flex justify-between border-white-2.0 px-2 py-2',
                    className
                  )}
                >
                  <input
                    type="radio"
                    name="campaignRadio"
                    id={campaign.id}
                    onChange={handleSelectType}
                    checked={selectedType === campaign.id}
                  />
                  <label
                    role="presentation"
                    className="flex flex-col flex-1 ml-4 truncate cursor-pointer"
                    htmlFor={campaign.id}
                  >
                    <div>{campaign.name}</div>
                    <div className="text-xs text-gray-2.0">{campaign.id}</div>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </Modal>
    );
  }
);
